// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9714) return "static/chunks/9714-439ce5f0db4e6b65.js";
	if (chunkId === 2663) return "static/chunks/2663-c56b6798106d4c96.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1284":"22e573fc160db0b4","1365":"2dfce5523f727d47","1621":"1297f197cccc9910","2192":"52c1d886db1e8da5","2786":"367e9c3878baa4a1","3068":"53165c8b9f952699","3815":"8b43d6675efc4c62","5897":"0e5dbef45b6dabe8","6232":"cffed18c7e96c09a","7377":"5a40d6f72aba3854"}[chunkId] + ".js";
};